// Products authorized for RFQ planning, not new inventory records or invented SKU codes.
export const RFQ_FAMILIES = [
    {
        "category": "Cajas de Cartón Corrugado",
        "products": [
            {
                "salesProductId": "boxes_mailer_boxes",
                "name": "Cajas para envíos por correo (Mailer Boxes)"
            },
            {
                "salesProductId": "boxes_shipping_boxes",
                "name": "Cajas para transporte y envío"
            },
            {
                "salesProductId": "boxes_product_boxes",
                "name": "Cajas para productos"
            },
            {
                "salesProductId": "boxes_gift_presentation_boxes",
                "name": "Cajas para regalos y presentaciones"
            },
            {
                "salesProductId": "boxes_take_out_containers",
                "name": "Envases para comida para llevar"
            },
            {
                "salesProductId": "boxes_cake_pastry_boxes",
                "name": "Cajas para pasteles y productos de repostería"
            },
            {
                "salesProductId": "boxes_pizza_boxes",
                "name": "Cajas para pizza"
            }
        ]
    },
    {
        "category": "Etiquetas",
        "products": [
            {
                "salesProductId": "labels_paper_labels",
                "name": "Etiquetas de papel"
            },
            {
                "salesProductId": "labels_bopp_labels",
                "name": "Etiquetas BOPP"
            },
            {
                "salesProductId": "labels_clear_labels",
                "name": "Etiquetas transparentes"
            },
            {
                "salesProductId": "labels_foil_labels",
                "name": "Etiquetas con acabado de foil (lámina metalizada)"
            },
            {
                "salesProductId": "labels_metallic_labels",
                "name": "Etiquetas metalizadas"
            },
            {
                "salesProductId": "labels_direct_thermal_thermal_transfer_labels",
                "name": "Etiquetas térmicas"
            },
            {
                "salesProductId": "labels_shrinkable_labels",
                "name": "Etiquetas termoencogibles"
            }
        ]
    },
    {
        "category": "Empaques Flexibles",
        "products": [
            {
                "salesProductId": "flexible_stand_up_pouches",
                "name": "Bolsas tipo Stand-Up Pouch"
            },
            {
                "salesProductId": "flexible_lay_flat_pouches",
                "name": "Bolsas planas (Lay-Flat Pouch)"
            },
            {
                "salesProductId": "flexible_stick_pack_packaging",
                "name": "Empaques tipo stick (sobres alargados)"
            },
            {
                "salesProductId": "flexible_sachet_pack_packaging",
                "name": "Empaques tipo sachet (sobres individuales)"
            },
            {
                "salesProductId": "flexible_laminated_bags",
                "name": "Bolsas laminadas"
            }
        ]
    },
    {
        "category": "Vasos y Tapas",
        "products": [
            {
                "salesProductId": "cups_hot_paper_cups",
                "name": "Vasos de papel para bebidas calientes + tapas"
            },
            {
                "salesProductId": "cups_cold_paper_cups",
                "name": "Vasos de papel para bebidas frías + tapas"
            },
            {
                "salesProductId": "cups_ice_cream_cups",
                "name": "Vasos para helado + tapas"
            },
            {
                "salesProductId": "cups_plastic_cups",
                "name": "Vasos plásticos + tapas"
            }
        ]
    }
];
const key = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
const categoryAliases = [
    ['Cajas de Cartón Corrugado', ['Cajas', 'Cajas y Cartones', 'Cartones y Corrugados', 'Cajas de Cartón Corrugado']],
    ['Etiquetas', ['Etiquetas']],
    ['Empaques Flexibles', ['Empaque flexible', 'Empaques Flexibles', 'BOLSAS LAMINADAS']],
    ['Vasos y Tapas', ['Vasos', 'Vaso', 'Tapas', 'Tapa', 'Vasos y Tapas']]
];
export function rfqCategory(value) {
    return categoryAliases.find(([, aliases]) => aliases.some(alias => key(alias) === key(value)))?.[0] || '';
}
export const isRFQFamily = product => product?.catalogKind === 'rfq-family';
export const productLabel = product => product.code ? `${product.code} · ${product.name}` : isRFQFamily(product) ? `${product.name} · Producto de cotización` : product.name;
export function extendRFQCatalog(data, categoryOf) {
    if (!data || data.businessUnit !== 'empaque') return data;
    const original = data.products.filter(p => !isRFQFamily(p));
    const products = original.filter(p => p.businessUnit === 'empaque' && p.status !== 'archived');
    const byId = new Map(products.map(p => [String(p._id), p]));
    const activeSuppliers = new Set(data.suppliers.filter(s => s.active).map(s => String(s._id)));
    const baseRelations = data.relations.filter(r => !r.rfqFamily);
    const coverage = new Map();
    for (const relation of baseRelations) {
        const product = byId.get(String(relation.product));
        if (!product || !activeSuppliers.has(String(relation.supplier))) continue;
        const category = rfqCategory(categoryOf(product));
        if (!category) continue;
        if (!coverage.has(category)) coverage.set(category, new Set());
        coverage.get(category).add(String(relation.supplier));
    }
    const families = RFQ_FAMILIES.flatMap(group => group.products.map(product => ({
        _id: 'rfq-family:' + product.salesProductId, salesProductId: product.salesProductId,
        name: product.name, code: '', category: group.category, businessUnit: 'empaque',
        status: 'active', baseUnit: '', catalogKind: 'rfq-family'
    })));
    const familyRelations = data.supplierSource === 'sales'
        ? families.flatMap(product => data.suppliers.filter(s => s.active && s.salesCategories?.includes(product.category) &&
            (!s.salesRestrictedCategories?.includes(product.category) || s.salesProducts?.includes(product.salesProductId))).map(s => ({
                product: product._id, supplier: String(s._id), basis: 'Proveedor relacionado con la subcategoría',
                category: product.category, rfqFamily: true, requiresConfirmation: true
            })))
        : families.flatMap(product => [...(coverage.get(product.category) || [])].map(supplier => ({
            product: product._id, supplier, basis: 'Proveedor relacionado con la subcategoría',
            category: product.category, rfqFamily: true, requiresConfirmation: true
        })));
    return {...data, products: [...original, ...families], relations: [...baseRelations, ...familyRelations], rfqFamilyCount: families.length};
}
export function quotationFamily(line, products) {
    const families = products.filter(p => isRFQFamily(p) && p.businessUnit === 'empaque');
    const byId = families.filter(p => p.salesProductId === line.productId);
    if (byId.length === 1) return byId[0];
    if (byId.length) return null;
    const byName = families.filter(p => key(p.name) === key(line.productName));
    return byName.length === 1 ? byName[0] : null;
}
